<template>
  <v-container class="usuarios">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <v-form>
        <PageTitle
          main="Administração"
          icon="mdi-pencil-box-outline"
          sub="Cadastro de menus do sistema"
          home="/administracao"
        />
        <menu-sys />
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import MenuSys from '../components/MenuAdmin.vue'
export default {
  name: 'Menus',
  components: { PageTitle, MenuSys },
  data: () => ({

  })
}
</script>
